import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { 
  User, 
  CreditCard, 
  Shield, 
  Link2 
} from "lucide-react";
import { cn } from "@/lib/utils";

export const SettingsSidebar = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  const navItems = [
    {
      path: "/settings/profile",
      icon: User,
      label: t("settings.nav.profile"),
    },
    {
      path: "/settings/subscription",
      icon: CreditCard,
      label: t("settings.nav.subscription"),
    },
    {
      path: "/settings/security",
      icon: Shield,
      label: t("settings.nav.security"),
    },
    {
      path: "/settings/connections",
      icon: Link2,
      label: t("settings.nav.connections"),
    },
  ];

  return (
    <nav className="flex flex-col items-start space-y-2">
      {navItems.map((item) => (
        <Button
          key={item.path}
          variant="ghost"
          className={cn(
            "w-52 h-10 px-4 justify-start font-bold text-base transition-all",
            isActive(item.path)
              ? "bg-[#4DA6FF] text-white border-2 border-black shadow-[4px_4px_0_#000] translate-x-[-2px] translate-y-[-2px] hover:bg-[#4DA6FF] hover:translate-x-[-2px] hover:translate-y-[-2px] hover:shadow-[4px_4px_0_#000]"
              : "text-muted-foreground hover:bg-[#4DA6FF]/20 hover:text-foreground hover:border-2 hover:border-black hover:translate-x-[-2px] hover:translate-y-[-2px] hover:shadow-[4px_4px_0_#000]"
          )}
          onClick={() => navigate(item.path)}
        >
          <item.icon className="w-4 h-4 mr-2" />
          {item.label}
        </Button>
      ))}
    </nav>
  );
};
